/* Component Dependencies */
var countryConsentTemplate = require('templates/countryConsent.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var Popup = require('libs/popup');

AriesComponent.create({
  
  type: 'countryConsent',
  
  template: {
    'countryConsent': countryConsentTemplate
  },

  subscribe: {
    'COUNTRY_CONSENT': 'countryChangeRefresh',
    'TOGGLE_CONSENT': 'initCheck',
    'SEND_OTP_TXN_VALUE': 'setOtpTxnValue'
  },
  
  events: {
    'click .js-select-all-consents': 'handleConsentCheckboxes',
		  'click .js-select-consent': 'handleConsentCheckboxes',
    'click .js-required-consent a': 'termsConsenthandler',
    'click .js-optional-consent a': 'termsConsenthandler',
  },

  bindEvents: function() {
     //on click of terms for south Korean consent checkbox the popup would be triggered
     var sectionNode =$('#country-consent').closest("div.l-row");
     var isCnLocaleVal = this.$el.find('input[name="isCnLocale"]').val();
     sectionNode && sectionNode.addClass("overflow-x-hidden");
      var consentPopup = new Popup({
        selector: ".tile-country-consent .js-enrollment-modal .js-required-consent a:not(.external-site),.tile-country-consent .js-enrollment-modal .js-optional-consent a:not(.external-site),.tile-country-consent .js-agreement-modal p:not(.modal-link) a:not(.external-site)",
        sourceBlock: ".modal-content",
        alternateCloseMarkup: true,
        contentLoaded: function() {
          //Once the popup content loads - iterate through the terms link of consent checkbox and check which terms link
          //(associated with the consent checbox) was clicked through popup-triggered class and add
          //data-consent-checked to I AGREE button, so respective checkbox is checked on click on I AGree.
          $('.js-select-terms-link').each(function() {
            if(($(this).hasClass('popup-triggered'))){
             var consentChecked = $(this).data('terms-consent')
             $(".js-agree-button").attr('data-consent-checked', consentChecked);
             $(this).removeClass('popup-triggered');
            }
         });
        }
      });
      consentPopup.register();
      this.isFreshLoad();
      
     this.isCnLocaleVal = $('input[name="isCnLocale"]').val();
     this.isMobileVerificationRequiredVal = $('input[name="isMobileVerificationRequired"]').val();
     this.jsConsentCheckBox = $('.js-select-consent')
     this.isCnLocaleVal && this.disableConsentCheckBox();
     var requiredConsent = this.$el.find('.js-required-consent');
     var requiredOptionalConsent = this.$el.find('.js-required-consent,.js-optional-consent');
     if ($('.user-web-checkin').length > 0){
      if (requiredConsent.length > 0){
        requiredConsent.parent().addClass("ocj-padding-right");
        requiredConsent.addClass('ocj-margin-right');
      }
      requiredOptionalConsent.addClass('l-xl-col-12 l-l-col-12').removeClass('l-xl-col-9 l-l-col-9');
    }
    var isHybridRrd = this.$el.find('#isHybridRRD').val();
    var isHybridRrdFlow = isHybridRrd === "true";
    this.currentCountryCode =  $('.js-search-country').val();
    this.isGuestInfo =  this.$el.find('#isGuestInfo').val() === "false";
    this.userProfileState =  this.$el.find('#userProfileState').val();
    /* Hybrid RRD SK country design changes*/
    if(isHybridRrdFlow && this.currentCountryCode === "KR"){
      $('.tile-country-consent > .js-enrollment-modal:nth-of-type(2)').removeClass("t-border-top l-padding-bottom");
      $('.tile-country-consent > .js-enrollment-modal:nth-of-type(5)').removeClass("t-border-top");
      $('.tile-country-consent > .js-enrollment-modal:nth-of-type(4)').removeClass("t-border-top l-padding-bottom");
      $('.tile-country-consent > .js-enrollment-modal:nth-of-type(3)').removeClass("t-border-top l-padding-bottom");
    }
    if(this.isGuestInfo && this.userProfileState === "Authenticated"){
      $('.tile-country-consent > .js-required-consent-label,.js-enrollment-modal').removeClass("gray-background-content");
      $(".js-flexible-rate").closest(".js-required-consent-label").addClass("t-border-top t-border-color-standard-110");
      $(".js-required-consent").closest(".js-enrollment-modal").addClass("t-border-bottom t-border-color-standard-110 l-margin-bottom-one-and-half");
    }

  }, 
  isFreshLoad: function() {
    this.instantCheck = $('#guest-join-now');
    this.optionalCheckboxes = $('.show-section-instant input[type=checkbox]');
    this.isEnrollForm = $("#isEnrollForm").val() === "false";
    this.isInstantChecked ? this.allConsentToggle("show") : this.allConsentToggle("hide");
  },

  initCheck: function(data) {
    this.isInstantChecked = data;
    this.isFreshLoad();
    this.handleConsentCheckboxes();
  },
  allConsentToggle: function(toggleContent) {
    if(this.isEnrollForm){
    var isToggleContent = toggleContent == "show";
    var sectionOnInstantJoinAndAgreementModal = $(".js-instant-join-section,.js-agreement-modal");
    var memberRateStatement = this.$el.find(".js-member-rate").closest(".js-required-consent-label");
    var flexibleRateStatement = this.$el.find(".js-flexible-rate").closest(".js-required-consent-label");
    var reservationModal = this.$el.find('.js-reservation-modal').closest(".js-enrollment-modal");
    var optionalConsents = this.$el.find(".js-optional-consent").closest(".js-enrollment-modal");
    var requiredConsents = this.$el.find(".js-required-consent").closest(".js-enrollment-modal");
    var userProfileState = this.$el.find('#userProfileState').val();
    var currentCountry = this.$el.find('#profileCountry').val();
    var userRequiredConsentVisible = this.$el.find('#requiredConsentVisible').val();
    var userOptionalConsentVisible = this.$el.find('#communicationOptionsConsentVisible').val();
    var authUser = userProfileState === "Authenticated";
    var isRequiredConsentVisible = userRequiredConsentVisible === 'true';
    var isOptionalConsentVisible = userOptionalConsentVisible === 'true';
    var privacyConsentSection = $(".js-privacy-consent");
    var privacyConsentOptional = $(".js-privacy-consent-optional");
    var showPrivacyConsentSection = (isRequiredConsentVisible && isOptionalConsentVisible) ? "show" : "hide";
    var toggleRequiredConsents =  isRequiredConsentVisible ? "show" : "hide";
    var toggleOptionalConsents =  isOptionalConsentVisible ? "show" : "hide";
    var toggleMemberPrivacySection = isToggleContent ? "show" : "hide";
    var toggleFlexibleReservationSection = isToggleContent ? "hide" : "show";
    var agreementSection = this.$el.find(".js-agreement-modal");
    var optionalOnlyShow = !isRequiredConsentVisible && isOptionalConsentVisible && !this.isGuestInfo;
    var togglePrivacyOptional = optionalOnlyShow ? "show" : "hide";
    if(!authUser){
      memberRateStatement[toggleMemberPrivacySection]();
      sectionOnInstantJoinAndAgreementModal[toggleMemberPrivacySection]();
      flexibleRateStatement[toggleFlexibleReservationSection]();
      reservationModal[toggleFlexibleReservationSection]();
    } else{
      privacyConsentSection[showPrivacyConsentSection]();
      privacyConsentOptional[togglePrivacyOptional]();
      flexibleRateStatement[toggleRequiredConsents]();
      requiredConsents[toggleRequiredConsents]();
      optionalConsents[toggleOptionalConsents]();
      agreementSection.hide();
      memberRateStatement.hide();
      if(optionalOnlyShow){ 
        optionalConsents.removeClass("l-margin-top-one-and-half")
      }
      if(currentCountry == "JP"){
        sectionOnInstantJoinAndAgreementModal.hide();
      }
    }
  }
    this.passingCheckboxName();
    this.optionalCheckboxes.prop('disabled', !isToggleContent);
  },
  disableConsentCheckBox: function(){
    var _self = this;
    var submitBtn = $('.js-submit-button');
    var krRequiredConsents = '.js-kr-required-consent';
    
    _self.skCountryCode = "KR";
    if (_self.isMobileVerificationRequiredVal) {
      _self.jsConsentCheckBox.each(function () {
        if($(this).is(':checked')){
          $(this).prop("disabled",false).addClass("js-otp-flow-toggle");
          submitBtn.prop("disabled",false);
        } else {
          _self.countryCode == "CN" && (_self.otpTxnValue != undefined && _self.otpTxnValue !== "" ?  $(this).prop("disabled",false) :  $(this).prop("disabled",true));
          $(this).addClass("js-otp-flow-toggle");
          submitBtn.prop("disabled",true);

          _self.countryCode == _self.skCountryCode && ($(krRequiredConsents).length == $(krRequiredConsents).filter(':checked').length ? submitBtn.prop("disabled",false) : submitBtn.prop("disabled",true));
          
        }
        if(_self.countryCode == _self.skCountryCode && $(this).parent().hasClass('js-cn-locale-required')){
          $(this).addClass("js-kr-required-consent");
        }
     });
    }
  },
  handleConsentCheckboxes: function _handleConsentCheckboxes(e) {
    var _self = this;
    var selectedCheckbox = this.$el.find('.js-enrollment-modal .js-select-consent');
    var isAllConsentsSelected = this.$el.find('.js-select-all-consents');
    var allChecked = isAllConsentsSelected.prop('checked');
    var jsJoinBtn = $('.js-submit-button');
    if(e!=undefined && $(e.currentTarget).hasClass("js-select-all-consents")){
      selectedCheckbox.each(function() {
        if(!$(this).prop('disabled')) {
          $(this).prop('checked', allChecked);
        }
      })
    }else{
      if (isAllConsentsSelected.prop('checked') && e!=undefined && !$(e.currentTarget).prop("checked")) {
        isAllConsentsSelected.prop("checked", false);
      } else if($(selectedCheckbox).prop("checked")) {
          var atleastOneChildNotChecked = false;
          selectedCheckbox.each(function() {
          if(!$(this).prop('checked')) {
              atleastOneChildNotChecked = true;
              return false;
          }
        });
        isAllConsentsSelected.prop("checked", !atleastOneChildNotChecked);
      }
   }
   if (selectedCheckbox.hasClass('js-otp-flow-toggle')){
    _self.pubsub.publish('TOGGLE_JOIN_BTN', [undefined, jsJoinBtn]);  
   }
  },
  termsConsenthandler: function _termsConsenthandler(e){
			$(e.currentTarget).addClass('popup-triggered');
      var checkBoxId = $(e.currentTarget).data('terms-consent');
      $('#' + checkBoxId).filter(':visible').addClass('checkbox-popup-triggered');
  },
  setOtpTxnValue: function _setOtpTxnValue(otpVal){
    this.otpTxnValue = otpVal;
  },
  countryChangeRefresh: function _countryChangeRefresh(countryCode, isCnLocaleVal, countryCodeChange, checkInstantNowFlag) {
    var _self=this;
    _self.countryCode = countryCode;
    _self.countryCodeChange = countryCodeChange;
    _self.checkInstantNowFlag = checkInstantNowFlag;
      var context = {
        countryCode: _self.countryCode,
        isCnLocaleVal: isCnLocaleVal,
        isCountryCodeChange : _self.countryCodeChange,
        isCheckInstantNowFlag :  _self.checkInstantNowFlag
      }
      _self.refresh(context);
  },
  passingCheckboxName: function _passingCheckboxName(){
    var inputCheckbox = $("input.js-select-consent:checkbox");
    var requiredCheckboxArr = [];
    var optionalCheckboxArr = [];
    inputCheckbox.each(function () {
       if(!$(this).attr('disabled')){
        if($(this).attr('name').toLowerCase().includes('required')){
          requiredCheckboxArr.push($(this).attr('name'))
        } else {
          optionalCheckboxArr.push($(this).attr('name'))
        }
       }
    });
    $('#required-checkbox').val(requiredCheckboxArr);
    $('#optional-checkbox').val(optionalCheckboxArr);
  }
});
